import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { Bdmassessmentmodels } from '../bdm-assessment-models/bdmassessmentmodels.models';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BdmassessmentService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async saveBdmAssessment(bdmAssessment: Bdmassessmentmodels) {

    const API_URL: string = environment.baseUrl + environment.apis.savebdmAssessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: bdmAssessment.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewBdmAssessment(viewid: number, status: string) {

    const API_URL: string = environment.baseUrl + environment.apis.viewbdmAssessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboarding_id: viewid,
        updated_by_role: this.sessionStorageService.getCurrentUserRole() == 'DSU' || 'DSU Manager' ? 'BDM' : this.sessionStorageService.getCurrentUserRole(),
        status: this.sessionStorageService.getCurrentUserRole() == 'DSU' || 'DSU Manager' ? 'BDM Interview' : status,
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getBdmdocumentslist(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewdocumentslist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboardingId: viewid,
        updatedByRole: this.sessionStorageService.getCurrentUserRole() == 'DSU' || 'DSU Manager' ? ['BDM'] : [this.sessionStorageService.getCurrentUserRole()]
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}
